import { SideBarActionsPreview } from '../../../../../common/components/side-bar/SideBarActionsPreview'
import { Group } from '@wellesley/openapi'
import { FC, useCallback, useEffect, useRef, useState } from 'react'
import { defaultCover } from 'components/ProfileCover'
import { GroupJoinButton, ManageGroup, useGroupMember } from '@wellesley/group'
import { DropdownTitle } from '../../../../../common/components/side-bar/SideBarActionsPreview/actions/DropdownTitle'
import { useDispatch } from 'react-redux'
import { setSideBarCloseBlocked } from '../../../../../common/components/ToolbarItem/slice'
import { selectUploadFile } from '@wellesley/uploads'

type GroupPreviewProps = {
  group: Group
}
export const GroupPreview: FC<GroupPreviewProps> = ({ group }) => {
  const { displayName, banner, avatar } = group
  const [isOpen, setIsOpen] = useState(false)
  const { groupMember, isLoading } = useGroupMember(group.groupId)
  const isMember = groupMember?.state === 'MEMBER'

  const timerRef = useRef<NodeJS.Timeout | null>(null)
  const dispatch = useDispatch()

  const handleOpenModalChange = useCallback(
    (opened: boolean) => {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }

      if (opened) {
        dispatch(setSideBarCloseBlocked(true))
      } else {
        timerRef.current = setTimeout(() => {
          dispatch(setSideBarCloseBlocked(false))
        }, 2000)
      }
    },
    [dispatch],
  )

  useEffect(() => {
    return () => {
      dispatch(setSideBarCloseBlocked(false))
      timerRef.current && clearTimeout(timerRef.current)
    }
  }, [])

  return (
    <SideBarActionsPreview
      cover={
        selectUploadFile({
          upload: banner,
          size: 400,
          allowWithoutSize: true,
        })?.uri || defaultCover
      }
      avatar={
        selectUploadFile({
          upload: avatar,
          size: 48,
          allowWithoutSize: true,
        })?.uri || ''
      }
      title={displayName}
      mainAction={
        !isMember && !isLoading ? (
          <GroupJoinButton
            key="join-button"
            group={group}
            onOpenRulesModalChange={handleOpenModalChange}
          />
        ) : null
      }
    >
      <ManageGroup
        align="start"
        alignOffset={16}
        group={group}
        onOpenChange={setIsOpen}
        isPortal={false}
        trigger={<DropdownTitle title={displayName} isOpen={isOpen} />}
        triggerClass="min-w-m w-full flex size-full"
        desktopModalBehavior={false}
        onInviteOpenChange={handleOpenModalChange}
      />
    </SideBarActionsPreview>
  )
}
